const API_URL = {
  LOGIN: "auth/login",
  VERIFICATION: {
    LOGIN: "Identity/verification/login",
    REFRESH_TOKEN: "Identity/refreshToken",
    SEND_OTP: "Identity/sendOTP",
    VERIFY_OTP: "Identity/verifyOTP",
    REGISTER: "Identity/Verification/CreateVerificationUser",
    CHANGE_PASSWORD: "Identity/changePassword",
    USER_PROFILE_DATA: "Identity/GetUserDetail",
    GET_MODULE_RIGHT: "Identity/Verification/GetUserModuleRights",
    GET_DIVISIONS: "verification/Division",
    GET_TEAMS: "verification/Team",
    GET_DOCUMENTS: "/Verification/Document",
    GET_FORMS: "/Verification/Form",
    PING: "/Verification/ping",
  },
  CANDIDATE: {
    SLUG: "verification/Candidate",
    CLOSE_CANDIDATE: "verification/Candidate/CloseCandidate",
    BLOCK_CANDIDATE: "verification/Candidate/BlockCandidate",
    REACTIVATE_CANDIDATE: "verification/Candidate/ReActivateCandidate",
    SEND_MESSAGE: "verification/CandidateApplication/sendmessage",
    GET_MESSAGE_LIST: "verification/CandidateApplication/Messages",
    GET_NC_STATUS: "verification/Candidate/GetNCStatus",
    CHANGE_NC_STATUS: "verification/Candidate/UpdateNCStatus",
    GET_CANDIDATE_TYPE: "verification/Candidate/GetCandidateTypes",
    GET_MESSAGE_DETAIL_BY_ID: "verification/CandidateApplication/Message",
    GET_APPLICATION_STATUS: "Verification/Candidate/GetApplicationStatus",
    COMPLIANCE_SCORE: "verification/Candidate", // used as `${SLUG}/${id}/ComplianceScore`
    UPDATE_NOTES: "verification/Candidate/UpdateCandidateNotes",
  },
  CANDIDATE_APPLICATION: {
    SLUG: "verification/CandidateApplication",
    ADD_FORMS_AND_DOCUMENTS:
      "verification/CandidateApplication/AddFormsAndDocuments",
    ASSIGN_USER_TO_CANDIDATE:
      "verification/CandidateApplication/AssignUserToCandidate",
    ASSIGN_RECRUITER_TO_CANDIDATE:
      "verification/CandidateApplication/AssignRecruiterToUser",
    GET_CANDIDATE_FORMS: "verification/CandidateApplication/GetCandidateForms",
    GET_CANDIDATE_DOCUMENTS:
      "verification/CandidateApplication/GetCandidateDocuments",
    RESEND_LINK: "verification/CandidateApplication/ResendLink",
    SEND_REGISTRATION_LINK:
      "verification/CandidateApplication/AddFormsAndDocuments",
    ADD_CANDIDATE_FORM_DOCS:
      "verification/CandidateApplication/AddMoreFormsAndDocuments",
    GET_FORMS_DOCUMENTS: "verification/CandidateApplication/GetFormsDocuments",
    UPDATE_FORM_COMPLIANCE_NOTES:
      "verification/CandidateApplication/UpdateFormComplianceNotes",
    UPDATE_DOCUMENT_COMPLIANCE_NOTES:
      "verification/CandidateApplication/UpdateDocumentComplianceNotes",
    DOWNLOAD_FORM: "verification/CandidateApplication/downloadForm",
    DOWNLOAD_DOCUMENT: "verification/CandidateApplication/downloadDocument",
    FORM_HISTORY: "verification/CandidateApplication/formHistory",
    DOCUMENT_HISTORY: "verification/CandidateApplication/documentHistory",
    DELETE_FORM: "verification/CandidateApplication/deleteForm",
    DELETE_DOCUMENT: "verification/CandidateApplication/deleteDocument",
    HISTORY: "verification/CandidateApplication/history",
    TEMPLATE: "verification/CandidateApplication/PreviewSendLink",
    REJECTED_REASON: "verification/CandidateApplication/Rejected",
  },
  USER: {
    SLUG: "verification/User",
    CREATE_USER: "verification/User/CreateUser",
    GET_ASSIGNEE_USER: "verification/User/GetAllAssigneeUser",
    GET_RECRUITER_USER: "verification/User/GetAllRecruiters",
  },
  CANDIDATES: {
    SLUG: "Candidates",
    UPLOAD_PROFILE: "Candidates",
  },
  ROLE: {
    SLUG: "verification/Role",
    ROLE_RIGHT: "verification/RoleRight",
    GET_ROLE: "Verification/Role/Roles",
  },
  MESSAGE: {
    SLUG: "verification/Message",
  },
  FRAMEWORK: {
    SLUG: "verification/Framework",
  },
  REQUIREMENT_PROFILE: {
    SLUG: "verification/RequirementProfile",
  },
  EXPIRY_CONFIG: {
    GET_FORM: "Verification/ExpiryConfig/Form",
    UPDATE_FORM: "Verification/ExpiryConfig/Form",
    GET_DOCUMENT: "Verification/ExpiryConfig/Document",
    UPDATE_DOCUMENT: "Verification/ExpiryConfig/Document",
  },
  EXPIRY_NOTIFICATION: {
    LOGS: "Verification/ExpiryNotification/Logs",
    RESEND: "Verification/ExpiryNotification/Resend",
    PROCESS: "Verification/ExpiryNotification/Process",
  },
  DASHBOARD: {
    EXPIRY_SUMMARY: "Verification/Dashboard/GetExpirySummary",
    EXPIRY_DETAILS: "Verification/Dashboard/GetExpiryDetails",
    PRODUCTIVITY_OVERVIEW: "Verification/Dashboard/GetProductivityOverview",
    PRODUCTIVITY_OVERVIEW_EXPORT: "Verification/Dashboard/GetProductivityOverviewExport",
    BELOW_THRESHOLD: "Verification/Dashboard/BelowThreshold",
  },
  METADATA_FIELD: {
    GET_BY_FORM: "Verification/MetadataField/Form",
    GET_BY_DOCUMENT: "Verification/MetadataField/Document",
    CREATE: "Verification/MetadataField",
    UPDATE: "Verification/MetadataField",
    DELETE: "Verification/MetadataField",
    SET_REFERENCE_DATE_FORM: "Verification/MetadataField/ReferenceDate/Form",
    SET_REFERENCE_DATE_DOCUMENT: "Verification/MetadataField/ReferenceDate/Document",
  },
};

export default API_URL;
